import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
import { AlertService } from '../../_services/alert.service';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-user-list',
  templateUrl: './admin-user-list.component.html',
  styleUrls: ['./admin-user-list.component.css']
})
export class AdminUserListComponent implements OnInit {

  userList: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  totalRecords: number;

  constructor(private http: HttpClient, private alertService: AlertService, private excelService: ExcelServiceService, private api: ApiIntegration, private g: Globals) {
    this.g.page = "User List";
    this.getAllAdminUsers();
  }

  exportToXLSX() {
    this.excelService.exportAsExcelFile(this.userList, 'sample');
  }

  getAllAdminUsers() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      serverSide: true,
      language: {
        searchPlaceholder: 'Search by First Name / Last Name / Email Address'
      },
      ajax: (dataTablesParameters: any, callback) => {
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getAllAdminUsers/1/ALL';
        let query: any = {
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.userList = resp.usersData;
            this.totalRecords = resp.noOfRecords;
            this.g.loaderDisplay = "";
            callback({
              recordsTotal: resp.noOfRecords,
              recordsFiltered: resp.noOfRecords
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };


    // this.g.loaderDisplay="display";
    //           this.api.getAllAdminUsers("1","ALL").subscribe((data: any) => {
    //             this.g.loaderDisplay="";

    //                       this.userList = data;
    //                       this.rerender();
    //                     }, err => {
    //                       this.g.loaderDisplay="";

    //                    this.alertService.error('Error',err);
    //                     });
  }

  changeStatus(notImpl) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

}
